import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-document',
    templateUrl: './document.component.svg',
    styleUrls: ['./document.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentComponent {}
